import { serializeQueryParams } from '../../../helpers/url';
import * as keyTransformers from '../../../helpers/keysTransformers';
import { createHttp } from '../../http';

export const dadata = createHttp<
  undefined,
  {
    apiKey: string;
  },
  {
    /**
     * Object will be converted to string and send as body
     */
    json?: Record<string, any>;

    /**
     * Object will be converted to query string
     *
     * @example { k1: 'v1', k2: 'v2' } => ?k1=v1&k2=v2
     */
    queryParams?: Record<string, any>;
  }
>();

dadata.addRequestInterceptor(
  ({ customOptions, url, params: { headers, ...params } }) => {
    headers = {
      ...headers,
      Accept: 'application/json',
      Authorization: `Token ${dadata.getVariable('apiKey')}`,
    } as Record<string, string>;

    if (params.json) {
      headers['Content-Type'] = 'application/json';
      const json = keyTransformers.decamelize(params.json);
      params.body = JSON.stringify(json);
    }

    url = `https://suggestions.dadata.ru/suggestions/api/4_1/rs${url}`;
    if (params.queryParams) {
      url = `${url}${serializeQueryParams(params.queryParams, {
        addQueryPrefix: true,
      })}`;
    }

    return {
      customOptions,
      url,
      params: {
        ...params,
        headers,
      },
    };
  }
);

dadata.addResponseInterceptor(({ response: { result, ...response } }) => {
  if (result) {
    try {
      result = JSON.parse(result);
      result = keyTransformers.camelize(result);
    } catch {
      // no actions
    }
  }

  return {
    ...response,
    result,
  };
});
